<template>
  <div>
    <b-card v-if="true" no-body class="overflow-hidden">
      <b-row no-gutters>
        <b-embed
          type="iframe"
          aspect="16by9"
          src="https://www.youtube.com/embed/zpOULjyy-n8?rel=0"
          allowfullscreen="false"
        />
      </b-row>
      <b-row no-gutters>
        <b-card-body title="Can't Fight this Feeling Anymore">
          <b-card-text v-if="hasSelectedBy">
            <b-img
              v-bind="mainProps"
              :src="selectedByImgURL"
              rounded="circle"
              alt="Circle image"
              left
            />
            <h4>Selected by {{ selectedByRole }} {{ selectedByName }}</h4>
          </b-card-text>
        </b-card-body>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "AudioRow",
  props: {
    audio: {
      type: Object,
      default: () => {}
    },
    assetsUrlHome: {
      type: String,
      default: ""
    }
  },
  computed: {
    coverImgURL() {
      return this.audio.imgURL
        ? `${this.assetsUrlHome}${this.audio.imgURL}`
        : "";
    },
    iconImgProps() {
      if (this.audio.imgURL) {
        this.mainProps.src = `${this.assetsUrlHome}${this.audio.imgURL}`;
      }
      return this.mainProps;
    },
    hasSelectedBy() {
      return Object(this.audio).hasOwnProperty("selectedBy");
    },
    selectedByName() {
      return this.hasSelectedBy ? this.audio.selectedBy.name : "";
    },
    selectedByRole() {
      return this.hasSelectedBy ? this.audio.selectedBy.role : "";
    },
    selectedByImgURL() {
      return this.hasSelectedBy ? this.audio.selectedBy.imgURL : "";
    },
    createdAt() {
      return this.hasSelectedBy ? this.audio.selectedBy._created_at : "";
    }
  },
  data() {
    return {
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
